import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Megaphone } from '@phosphor-icons/react';

import { bubbleImageSrc } from '@/lib/bubbleImage';
// Inline ad card meant to be sprinkled into the feed.
const AdSlot = ({ placement = 'feed' }) => {
  const [ad, setAd] = useState(null);
  useEffect(() => {
    api.get(`/ads?placement=${placement}`).then(({ data }) => {
      if (data.ads && data.ads.length) {
        setAd(data.ads[Math.floor(Math.random() * data.ads.length)]);
      }
    });
  }, [placement]);
  if (!ad) return null;
  return (
    <article className="snap-start min-h-[calc(100vh-9rem)] flex items-center px-4 sm:px-8 py-8">
      <div className="w-full max-w-3xl mx-auto grad-border p-6 sm:p-10 relative overflow-hidden" data-testid={`ad-${ad.id}`}>
        <div className="absolute -top-20 -right-20 h-60 w-60 rounded-full blur-3xl bg-bx-magenta/30 pointer-events-none" />
        <div className="absolute -bottom-20 -left-20 h-60 w-60 rounded-full blur-3xl bg-bx-cyan/30 pointer-events-none" />
        <div className="relative">
          <div className="chip text-bx-volt border-bx-volt/30 mb-4">
            <Megaphone size={12} weight="fill" /> Sponsored · {ad.placement}
          </div>
          {bubbleImageSrc(ad) && (
            <img src={bubbleImageSrc(ad)} alt={ad.title} className="rounded-xl max-h-64 mb-4" />
          )}
          <h2 className="font-display text-3xl sm:text-5xl font-black tracking-tighter leading-tight">{ad.title}</h2>
          {ad.subtitle && <p className="text-white/65 mt-2 text-base sm:text-lg">{ad.subtitle}</p>}
          <a
            href={ad.cta_url}
            target="_blank" rel="noreferrer"
            data-testid={`ad-cta-${ad.id}`}
            className="btn-primary px-6 py-3 rounded-full text-sm inline-flex items-center gap-2 mt-5"
          >
            {ad.cta_label || 'Learn more'}
          </a>
        </div>
      </div>
    </article>
  );
};

export default AdSlot;
